import React from "react";
import style from "./ContentSection.module.css";
import image from "../../../../public/EarnPhoto.png";
import { useNavigate } from "react-router-dom";

const ContentSection = () => {
  const navigate = useNavigate();
  return (
    <img
      onClick={() => navigate("/create-content")}
      className={style.image}
      src={image}
      alt=""
    />
  );
};

export default ContentSection;
